// extracted by mini-css-extract-plugin
export default {"ant-scrolling-effect":"ResetPasswordScreen_ant-scrolling-effect__zo89K","container":"ResetPasswordScreen_container__xQUdx"};